import { z } from 'zod';

import { zodSuppliersOverviewFiltersSchema } from '../useQuerySuppliersOverview/validations';

/**
 * Zod schema for the suppliers overview counts query parameters. Mirrors the
 * overview filters (without pagination).
 */
export const zodSuppliersOverviewCountsQueryParamsSchema =
  zodSuppliersOverviewFiltersSchema;

/**
 * Zod schema for the suppliers overview counts API response (ActivationStatusCountResponse).
 *
 * Field names are camelCase because the ky client converts snake_case API response
 * keys (completely_active, partially_active, integration_planned) to camelCase.
 */
export const zodSuppliersOverviewCountsResponseSchema = z.object({
  activationPossible: z.number().int().nonnegative().default(0),
  completelyActive: z.number().int().nonnegative().default(0),
  integrationPlanned: z.number().int().nonnegative().default(0),
  integrationRequested: z.number().int().nonnegative().default(0),
  partiallyActive: z.number().int().nonnegative().default(0),
});
